export class ProspectTourPayment {
    constructor (
        public ChargeAmount: number = 0,
        public ChargeCurrency: string = '',
        public ChargeToken: string = '',
        public ChargeEmail: string = '',
        public PropertyId: string = '',
    ) { }
}
